export const quota_cn_config = [
  {
    label: "intro_quota.cn.table_col1_txt1",
    col2: "",
    col2_flag: "ok",
  },
  {
    label: "intro_quota.cn.table_col1_txt2",
    col2: "intro_quota.text_1",
    col2_flag: "",
  },
  {
    label: "intro_quota.cn.table_col1_txt3",
    col2: "intro_quota.text_2",
    col2_flag: "",
  },
  {
    label: "intro_quota.cn.table_col1_txt4",
    col2: "",
    col2_flag: "ok",
  },
  {
    label: "intro_quota.cn.table_col1_txt5",
    col2: "",
    col2_flag: "ok",
  },
  {
    label: "intro_quota.cn.table_col1_txt6",
    col2: "intro_quota.text_3",
    col2_flag: "",
  },
  {
    label: "intro_quota.cn.table_col1_txt7",
    col2: "intro_quota.text_4",
    col2_flag: "",
  },
  {
    label: "intro_quota.cn.table_col1_txt8",
    col2: "",
    col2_flag: "ok",
  },
]

export const quota_hk_config = [
  {
    label: "intro_quota.hk.table_col1_txt1",
    col2:'intro_quota.text_16',
    col2_flag:'',
    col3:'',
    col3_flag:'ok'
  },
  {
    label: "intro_quota.hk.table_col1_txt2",
    col2:'intro_quota.text_17',
    col2_flag:'',
    col3:'intro_quota.text_1',
    col3_flag:''
  },
  {
    label: "intro_quota.hk.table_col1_txt3",
    col2:'',
    col2_flag:'error',
    col3:'intro_quota.text_6',
    col3_flag:''
  },
  {
    label: "intro_quota.hk.table_col1_txt4",
    col2:'',
    col2_flag:'error',
    col3:'intro_quota.text_7',
    col3_flag:''
  },
  {
    label: "intro_quota.hk.table_col1_txt5",
    col2:'',
    col2_flag:'error',
    col3:'',
    col3_flag:'ok'
  },
  {
    label: "intro_quota.hk.table_col1_txt6",
    col2:'intro_quota.text_16',
    col2_flag:'',
    col3:'intro_quota.text_3',
    col3_flag:''
  },
  {
    label: "intro_quota.hk.table_col1_txt7",
    col2:'intro_quota.text_4',
    col2_flag:'',
    col3:'intro_quota.text_12',
    col3_flag:''
  },
  {
    label: "intro_quota.hk.table_col1_txt8",
    col2:'intro_quota.text_4',
    col2_flag:'',
    col3:'intro_quota.text_13',
    col3_flag:''
  },
  {
    label: "intro_quota.hk.table_col1_txt9",
    col2:'intro_quota.text_4',
    col2_flag:'',
    col3:'intro_quota.text_14',
    col3_flag:''
  },
  {
    label: "intro_quota.hk.table_col1_txt10",
    col2:'intro_quota.text_10',
    col2_flag:'',
    col3:'intro_quota.text_11',
    col3_flag:''
  },
]

export const quota_us_config = [
  {
    label: "intro_quota.us.table_col1_txt1",
    col2:'',
    col2_flag:'ok',
    col3:'',
    col3_flag:'ok'
  },
  {
    label: "intro_quota.us.table_col1_txt2",
    col2:'intro_quota.text_5',
    col2_flag:'',
    col3:'',
    col3_flag:'ok'
  },
  {
    label: "intro_quota.us.table_col1_txt3",
    col2:'',
    col2_flag:'error',
    col3:'',
    col3_flag:'ok'
  },
  {
    label: "intro_quota.us.table_col1_txt4",
    col2:'',
    col2_flag:'error',
    col3:'',
    col3_flag:'ok'
  },
  {
    label: "intro_quota.us.table_col1_txt5",
    col2:'',
    col2_flag:'error',
    col3:'',
    col3_flag:'ok'
  },
  {
    label: "intro_quota.us.table_col1_txt6",
    col2:'intro_quota.text_5',
    col2_flag:'',
    col3:'intro_quota.text_3',
    col3_flag:''
  },
  {
    label: "intro_quota.us.table_col1_txt7",
    col2:'intro_quota.text_4',
    col2_flag:'',
    col3:'intro_quota.text_15',
    col3_flag:''
  },
  {
    label: "intro_quota.us.table_col1_txt8",
    col2:'',
    col2_flag:'ok',
    col3:'',
    col3_flag:'ok'
  },
  {
    label: "intro_quota.us.table_col1_txt9",
    col2:'intro_quota.text_10',
    col2_flag:'',
    col3:'intro_quota.text_11',
    col3_flag:''
  },
]
